import { state_select } from "Explore/Config/FilterData";

export const timeSpanOptions = [
  { label: "Last 5 years", value: 5 },
  { label: "Last 10 years", value: 10 },
  { label: "All", value: null },
];

export const indicatorList = [
  { label: "Total Publications", value: "total_publications" },
  { label: "Publications per Faculty", value: "publications_per_faculty" },
  { label: "Total Citations", value: "total_citations" },
  { label: "Citation per Faculty", value: "citation_per_faculty" },
  { label: "Citation per Paper", value: "citation_per_paper" },
  { label: "H-Index", value: "h_index" },
  { label: "Total Grant Funding", value: "total_grant_funding" },
  { label: "Grant Funding per Faculty", value: "grant_funding_per_faculty" },
  { label: "International Collaborations", value: "international_collaborations" },
];

export const sortDirectionOptions = [
  { label: "Descending", value: "desc" },
  { label: "Ascending", value: "asc" },
];

export const defaultBenchmarkFilter = {
  time_span: 10,
  location: state_select.slice(0, 3).map((item) => item.value),
  indicators: indicatorList.slice(0, 3).map((item) => item.value),
  order_by: indicatorList[0].value,
  order_direction: "desc",
  page: 0,
  page_size: 200,
};
